import { SITE } from "@/data/site";

/** The Sankofa gold bird mark. */
export const BirdMark = ({ className = "h-8 w-8", alt = "Sankofa bird emblem" }) => (
  <img
    src="/assets/sankofa-bird.png"
    alt={alt}
    loading="lazy"
    className={className}
    style={{ objectFit: "contain" }}
  />
);

/** Decorative faded bird motif for the top-right of light sections. */
export const CornerBird = ({ className = "" }) => (
  <img
    src="/assets/sankofa-bird.png"
    alt=""
    aria-hidden="true"
    loading="lazy"
    className={`pointer-events-none select-none absolute right-6 top-6 h-14 w-14 opacity-90 md:h-20 md:w-20 ${className}`}
  />
);

/** The full stacked wordmark used in header/footer. */
export const Wordmark = ({ dark = false, showTagline = true, size = "md" }) => {
  const nameColor = dark ? "text-white" : "text-navy";
  const subColor = dark ? "text-white/80" : "text-slate";
  const tagColor = dark ? "text-gold" : "text-slate/70";
  const nameSize = size === "sm" ? "text-lg" : "text-xl md:text-2xl";
  return (
    <div className="flex items-center gap-3">
      <BirdMark className={size === "sm" ? "h-9 w-9" : "h-11 w-11 md:h-12 md:w-12"} alt="Sankofa Launch Studio logo" />
      <div className="leading-none">
        <div className={`font-sans font-700 tracking-[0.18em] ${nameColor} ${nameSize}`} style={{ fontWeight: 700 }}>
          SANKOFA
        </div>
        <div className={`font-sans tracking-[0.30em] ${subColor} text-[0.6rem] md:text-xs mt-0.5`}>
          LAUNCH STUDIO
        </div>
        {showTagline && (
          <div className={`font-sans tracking-[0.14em] ${tagColor} text-[0.5rem] md:text-[0.6rem] mt-1 uppercase`}>
            {SITE.tagline}
          </div>
        )}
      </div>
    </div>
  );
};

/** Circular icon badge as seen in the deck. variant: navy | slate | white */
export const IconBadge = ({ icon: Icon, variant = "navy", className = "" }) => {
  const styles = {
    navy: "bg-navy text-white",
    slate: "bg-slate text-white",
    gold: "bg-gold text-navy-dark",
    outline: "bg-transparent border-2 border-gold text-gold",
  };
  return (
    <span
      className={`inline-flex h-16 w-16 items-center justify-center rounded-full ${styles[variant]} ${className}`}
    >
      <Icon className="h-7 w-7" strokeWidth={2} />
    </span>
  );
};
